export default function getFormValues(event) {
  const elementsArray = [...event.target.elements];
  return elementsArray.reduce((acc, elem) => {
    if (elem.id) {
      acc[elem.id] = elem.value;
    }

    return acc;
  }, {});
}
